var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.416,
    height: 53.416,
    viewBox: "0 0 53.416 53.416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(192 -103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(-192 103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M-139.419,126.37a.833.833,0,0,1-.537-.2l-25.337-21.25-25.337,21.25a.835.835,0,0,1-1.176-.1.835.835,0,0,1,.1-1.176l25.873-21.7a.835.835,0,0,1,1.073,0l25.873,21.7a.835.835,0,0,1,.1,1.176A.834.834,0,0,1-139.419,126.37Z",
    transform: "translate(192 -103)",
    fill: "#073448"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(-153.607 104.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M-136.819,116.685a.835.835,0,0,1-.835-.835v-9.181h-6.677v2.5a.835.835,0,0,1-.835.835.835.835,0,0,1-.835-.835v-3.339a.835.835,0,0,1,.835-.835h8.346a.835.835,0,0,1,.835.835V115.85A.835.835,0,0,1-136.819,116.685Z",
    transform: "translate(146 -105)",
    fill: "#073448"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(-186.992 128.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M-143.434,154.7H-166.8a.835.835,0,0,1-.835-.835v-19.2h-8.346v19.2a.835.835,0,0,1-.835.835h-8.346a.835.835,0,0,1-.835-.835V133h1.669v20.031h6.677v-19.2a.835.835,0,0,1,.835-.835H-166.8a.835.835,0,0,1,.835.835v19.2h21.7V133h1.669v20.866A.835.835,0,0,1-143.434,154.7Z",
    transform: "translate(186 -133)",
    fill: "#073448"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(-178.646 151.408)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 12,
    height: 2,
    transform: "translate(-0.354 0.008)",
    fill: "#073448"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(-180.315 154.747)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 15,
    height: 2,
    transform: "translate(0.315 -0.331)",
    fill: "#073448"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(-161.954 128.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M-146.819,143.016h-8.346a.835.835,0,0,1-.835-.835v-8.346a.835.835,0,0,1,.835-.835h8.346a.835.835,0,0,1,.835.835v8.346A.835.835,0,0,1-146.819,143.016Zm-7.512-1.669h6.677v-6.677h-6.677Z",
    transform: "translate(156 -133)",
    fill: "#073448"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f48bb90b8d2096df702717e0bfabec19.svg";
export { ForwardRef as ReactComponent };